import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-rezervuarov',
  templateUrl: './ob-rezervuarov.component.html',
  styleUrls: ['./ob-rezervuarov.component.scss']
})
export class ObRezervuarovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
